module.exports = __webpack_public_path__ + "img/w21-b2.121a779d.jpg";